import React, { Component, Fragment } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
} from "@material-ui/core";

import CheckEmployeeExistsForm from "./forms/CheckEmployeeExistsForm";
import CreateEmployeeForm from "./forms/CreateEmployeeForm";
import EmployeeViewForm from "./forms/EmployeeViewForm";
import CreateCompanyEmployeeForm from "./forms/CreateCompanyEmployeeForm";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class CreateEmployeeStepper extends Component {
  state = {
    activeStep: 0,
    email: "",
    exists: null,
  };

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  };

  handleNext = () => {
    this.setState({ activeStep: this.state.activeStep + 1 });
  };

  handleSuccess = (response) => {
    this.setState({ email: response.email.toLowerCase() });
    this.setState({ exists: response.exists });
    this.handleNext();
  };

  render() {
    return (
      <Fragment>
        <Stepper activeStep={this.state.activeStep} orientation="vertical">
          <Step>
            <StepLabel>Emailadres</StepLabel>
            <StepContent>
              <p>
                Vul het e-mailadres van de medewerker in. Indien de medewerker
                al in het systeem bestaat hoeft u zijn persoonsgegevens niet in
                te voeren.
              </p>
              <CheckEmployeeExistsForm onSuccess={this.handleSuccess} />
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Persoonsgegevens</StepLabel>
            <StepContent>
              {this.state.exists ? (
                credentials.user.isAdmin ? (
                  <EmployeeViewForm
                    email={this.state.email}
                    onSuccess={this.handleNext}
                  />
                ) : (
                  <Fragment>
                    <p>
                      Een medewerker met dit e-mailadres bestaat al in het
                      systeem en daarom hoeft zijn gegevens niet in te vullen.
                      Echter, vanwege de privacy kunt u zijn persoonsgegevens op
                      dit moment niet inzien.
                    </p>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleNext}
                    >
                      Verder
                    </Button>
                  </Fragment>
                )
              ) : (
                <CreateEmployeeForm
                  email={this.state.email}
                  onSuccess={this.handleNext}
                />
              )}
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Medewerkersgegevens</StepLabel>
            <StepContent>
              <CreateCompanyEmployeeForm email={this.state.email} />
            </StepContent>
          </Step>
        </Stepper>
      </Fragment>
    );
  }
}

export default CreateEmployeeStepper;



// WEBPACK FOOTER //
// ./src/components/CreateEmployeeStepper.js